export const network = [
    {
        name: 'Alexander von Humboldt',
        img: 'alexander.png',
        url: 'https://www.humboldt-foundation.de/en/explore/about-the-humboldt-foundation'
    },
    {
        name: 'CAPES',
        img: 'capes.png',
        url: 'https://www.gov.br/capes/pt-br/acesso-a-informacao/institucional/historia-e-missao'
    },
    {
        name: 'CIAg',
        img: 'ciag.png',
        url: 'https://www.ciag.org.br/quem-somos'
    },
    {
        name: 'CNPq',
        img: 'cnpq.png',
        url: 'https://www.gov.br/cnpq/pt-br/acesso-a-informacao/institucional/institucional'
    },
    // {
    //     name: 'Confiança',
    //     img: 'confianca.png',
    //     url: 'https://www.clienteconfianca.com.br/nossa-historia'
    // },
    // {
    //     name: 'CPFL',
    //     img: 'cpfl.png',
    //     url: 'https://www.grupocpfl.com.br/institucional/conheca-gente'
    // },
    {
        name: 'Eldorado',
        img: 'eldorado.png',
        url: 'https://www.eldorado.org.br/o-eldorado/'
    },
    {
        name: 'Einstein',
        img: 'einstein.png',
        url: 'https://www.einstein.br/n/o-einstein/sobre'
    },
    {
        name: 'FAPESP',
        img: 'fapesp.png',
        url: 'https://fapesp.br/sobre/'
    },
    // {
    //     name: 'FEPAF',
    //     img: 'fepaf.png',
    //     url: 'https://www.fepaf.org.br/instituicao/'
    // },
    // {
    //     name: 'FUNDEB',
    //     img: 'fundeb.png',
    //     url: 'https://www.fundeb.org.br/fundeb.html'
    // },
    // {
    //     name: 'FUNDUNESP',
    //     img: 'fundunesp.png',
    //     url: 'https://www.fundunesp.org.br/sobre/quem-somos'
    // },
    // {
    //     name: 'Itaú',
    //     img: 'itau.png',
    //     url: 'https://www.itau.com.br/relacoes-com-investidores/itau-unibanco/perfil-corporativo/'
    // },
    {
        name: 'Movement',
        img: 'movement.png',
        url: 'https://www.movement.com.br/quem-somos/'
    },
    {
        name: 'Petrobras',
        img: 'petrobras.png',
        url: 'https://petrobras.com.br/quem-somos/perfil'
    },
    {
        name: 'Unimed',
        img: 'unimed.png',
        url: 'https://www.unimedbauru.com.br/sobre'
    },
    {
        name: 'Weduu',
        img: 'weduu.png',
        url: 'https://weedu.com.br/sobre-nos/'
    },
    {
        name: 'XBRI',
        img: 'xbri.png',
        url: 'https://xbri.com.br/ajuda/sobre'
    }
]
